import { Client } from "./_clientService";

async function getTFGPlayers(params: any) {
  const resp = await new Client({ path: "" }).get();

  return resp.data;
}

async function getPBFPlayers(params: any) {
  const resp = await new Client({ path: "" }).get();
  return resp.data;
}

async function getManualPlayerInfo(cardId: any) {
  const resp = await new Client({
    path: "/player/manual/info",
    payload: { cardId },
  }).post();
  return resp;
}

async function markedAsRead(cardId: any) {
  const resp = await new Client({
    path: "/player/updates/markAsRead",
    payload: { updateId: cardId },
  }).post();
  return resp;
}

export async function readAll() {
  const resp = await new Client({
    path: "/player/updates/bulkMarkAsReadUpdate",
    payload: { input: { updateIds: null } },
  }).post();
  return resp;
}

export async function ignoreAndIgnoreAll(ids: any) {
  const resp = await new Client({
    path: "/player/updates/bulkIgnorePlayerUpdate",
    payload: { input: { updateIds: ids } },
  }).post();
  return resp;
}

export async function pullPlayerUpdates() {
  const resp = await new Client({
    path: "/misc/updateBasePlayers",
  }).post();
  return resp;
}

export { getTFGPlayers, getPBFPlayers, getManualPlayerInfo, markedAsRead };
